import {
  BUTTON_FOCUS_SHADOW_DISTANCE,
  buttonDimensionsFromSize,
} from 'omakase/Button/buttonCssDefs';
import { ButtonCoreSize } from 'omakase/Button/ButtonCore';
import { Theme, css } from '@emotion/react';

export const base = (
  { spacing, colors, breakpoints, interactiveStates }: Theme,
  hasBackgroundColor: boolean,
  isFullBleed: boolean
) => [
  interactiveStates.focus(css`
    outline: none;
    box-shadow: 0 0 0 2px var(--border-primary-base);
  `),
  css`
    background-color: ${hasBackgroundColor ? colors.bgLighter : colors.bgDefault};
  `,
  !isFullBleed &&
    css`
      border: 1px solid ${colors.borderDefault};
      margin: 0 ${spacing(2.5)}px;
      ${breakpoints.up('sm')} {
        margin: 0 ${spacing(3.5)}px;
      }
    `,
];

export const primaryContainer = ({ spacing, colors }: Theme) => css`
  display: flex;
  align-items: center;
  padding: ${spacing(2.5)}px;
  cursor: pointer;
  text-decoration: none;

  &::-webkit-details-marker {
    display: none;
  }
`;

export const primaryContainerInner = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const primaryChildContainer = (theme: Theme) => css`
  flex: 1;
  margin-right: ${theme.spacing(2.5)}px;
}
`;

export const iconContainer = (theme: Theme, buttonSize: ButtonCoreSize) => {
  const { height, iconDiameter } = buttonDimensionsFromSize(theme, buttonSize);

  return css`
    border: ${BUTTON_FOCUS_SHADOW_DISTANCE}px solid ${theme.colors.borderDefault};
    border-radius: ${height}px;
    width: ${iconDiameter}px;
    height: ${iconDiameter}px;
  `;
};

export const secondaryContainer = (theme: Theme) => css`
  padding: ${theme.spacing(2.5)}px;
  padding-top: 0;
`;

export const arrowContainerStyles = css`
  border-width: 1px;
  border-style: solid;
  &:hover {
    background-color: inherit !important;
  }
`;
